<template>
    <div>

        <el-tabs v-model="tabsKey" @tab-click="handleClick">
            <el-tab-pane label="查詢" name="search">
                <search @detailTabs="detailTabs" />
            </el-tab-pane>
            <el-tab-pane label="詳細" name="detail" v-if="isShowDetail">
                <detail :orderKey="orderKey" :orderTotal="total" @chreListTabs="chreListTabs" />
            </el-tab-pane>
              <el-tab-pane label="退換貨記錄" name="chrelist" v-if="isShowList">
                <chrelist :orderKey="orderKey" />
            </el-tab-pane>
            
        
        </el-tabs>
    </div>
</template>

<script>
 import search from './OrderChange/search'
 import detail from './OrderChange/detail'
 import chrelist from './OrderChange/chrelist'
    export default {
        name: 'orderChange',
        components: {
            search,
            detail,
            chrelist
        },
        data() {
            return {
                isShowDetail: false,
                isShowList: false,
                tabsKey: 'search',
                orderKey: '',
                total: null,
            }
        },
        methods: {
            detailTabs(orderKey, orderTotal){
                this.isShowDetail = true
                this.isShowList = false
                this.tabsKey ="detail"
                this.orderKey = orderKey,
                this.total = orderTotal
            },
           chreListTabs(orderKey){
                this.isShowList = true
                this.tabsKey = "chrelist"
                this.orderKey = orderKey
            },
            handleClick(tab, event){
                if (tab.name == 'search') {
                    this.isShowDetail = false
                    this.isShowList = false
                }
                if (tab.name == 'detail') {
                    this.isShowList = false
                }
            },
            back(){
                this.isShowDetail = false
            }
        },
    }
</script>

<style lang="scss" scoped>
    #tab-search {
       font-size: 16px;
       font-weight: bold;
    }
</style>